<template>
    <div>
        <!-- Encabezado de la aplicación -->
        <div class="appHeader no-border">
            <div class="left">
                <a href="#" class="headerButton goBack">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">
                Pagina de activación
            </div>
            <div class="right">
            </div>
        </div>
        <!-- * Encabezado de la aplicación -->

        <!-- Cápsula de la aplicación -->
        <div id="appCapsule">
            <div class="section">
                <div class="splash-page mt-5 mb-5">
                    <div class="iconbox mb-3">
                        <ion-icon name="refresh-outline"></ion-icon>
                    </div>
                    <h2 class="mb-2">¡Espera un momento!</h2>
                    <p>
                        <button class="btn btn-primary" type="button" disabled="">
                            <span class="spinner-grow spinner-grow-sm me-05" role="status" aria-hidden="true"></span>
                            Validando...
                        </button>
                    </p>
                </div>
            </div>
        </div>
        <!-- * Cápsula de la aplicación -->
    </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    async mounted() {
        this.$root.loadBackButtom();
        this.$root.loadInputs();

        const { k, u, e } = this.$route.query

        console.log('this.$route.query', k, u, atob(e))
        const response = await this.v1_validateAPI({
            username: u,
            email: atob(e),
            key: k,
        })
        console.log('response', response)
        if (response == true) {
            // this.$router.push({name:'login'})
            location.replace('/login')
        }
        //  else location.replace('/active-register')
        // } else this.$router.push({name:'active-register'})
    },
    methods: {
        ...mapActions(['v1_validateAPI']),
    }
}
</script>